import { useTheme } from 'styled-components';
import { LXCaption } from '../texts/lxText';
import Row from './box/row';
import Column from './box/column';
import SizedBox from './box/sizedBox';
import LXSider from '../../sider/sider';
import FlexBox from './box/flexBox';
import { Outlet } from 'react-router-dom';

const LXLayout = () => {
  const theme = useTheme();

  return (
    <Row>
      <LXSider></LXSider>
      <Column flexGrow={1} backgroundColor={theme.colors.grayBgLight}>
        <Outlet></Outlet>
        <FlexBox flexBasis="80px"></FlexBox>
        <LXCaption textAlign="center">
          {`© ${new Date().getFullYear()} ${theme.texts.allRightReserver}`}
        </LXCaption>
        <SizedBox height={16}></SizedBox>
      </Column>
    </Row>
  );
};

export default LXLayout;
